import React, { Component } from 'react'
import 'Styles/commonComponents.scss'
import IconsContainer from "Utils/IconsContainer";

export default class TransparentLoadIndicator extends Component {

    GetRunnerPart() {
        return (
            <div className='progress-bar-holder'>
                <div className='runner-load-indicator'>
                    <div>{ IconsContainer.Get('r-spinner') }</div>
                </div>
            </div>
        )
    }

    render() {
        let { total, loaded, inProgress, progress } = this.props.processInfo;

        if (progress == null)
            progress = Math.floor(loaded / total * 100);

        let element;

        if (total === 0)
            element = this.GetRunnerPart();
        else {
            if (loaded != null && total != null && loaded === total && inProgress === true)
                progress = 0;

            element = <div className='progress-bar-holder'>
                        <div className='progress-bar' style={ { width: `${ progress }%` } }/>
                        <div className='progress-description'>
                            { this.props.withoutIndicator === true ? '' :
                                <div className='runner-load-indicator'>
                                    <div>{ IconsContainer.Get('r-spinner') }</div>
                                </div>
                            }
                            { this.props.text } { progress }%
                        </div>
                    </div>
        }

        return (
            <div className={ "transparent-load-indicator " + (this.props.className == null ? '' : this.props.className) }>
                { element }
            </div>
        )
    }
}